"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var ExplanationComponent = function (props) { return (React.createElement(React.Fragment, null,
    React.createElement("p", null,
        React.createElement("strong", null, "Background")),
    React.createElement("p", null, "The USAC Modified Redpoint format was announced for the 2017-2018 bouldering season. It aims to create a fair ranking of competitors from the perspective of athletes and spectators, in a way that is simple to understand and follow."),
    React.createElement("p", null,
        React.createElement("strong", null, "Explanation")),
    React.createElement("p", null, "It focuses on 3 primary elements of performance: Tops, Zones and Falls. Competitors who control a Top-Zone handhold receives the points for that handhold."),
    React.createElement("p", null, "A deduction of 0.1 point is given to each fall recorded for the competitor's to reach his/her highest scored handhold for each problem."),
    React.createElement("p", null, "If there is a draw in points"),
    React.createElement("ol", null,
        React.createElement("li", null, "Points"),
        React.createElement("li", null, "Number of falls to achieve points in (1)"),
        React.createElement("li", null, "Number of Tops"),
        React.createElement("li", null, "Number of Flashes (Top in one attempt)"),
        React.createElement("li", null, "Number of falls to achieve Tops in (3)")),
    React.createElement("p", null, "The aim is to get the most Points or Tops, in the least amount of falls!"),
    React.createElement("p", null,
        React.createElement("strong", null, "Example")),
    React.createElement("p", null, "Coming soon!"))); };
exports.default = ExplanationComponent;
//# sourceMappingURL=ExplanationComponent.js.map


//////////////////
// WEBPACK FOOTER
// ../lib-score-systems/dist/scoreSystems/UsacModifiedRedpoint/ExplanationComponent.js
// module id = 1034
// module chunks = 0